export const ZASILKOVNA = 'zasilkovna';
export const ZASILKOVNA_BRANCH = 'zasilkovnaBranch';
export const ZASILKOVNA_SELECT_BRANCH = 'zasilkovnaSelectBranch';
